import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    list: [],
    selected: {},
    isLoaded: false,
};

const professionSlice = createSlice({
    name: "profession",
    initialState,
    reducers: {
        setProfessions: (state, { payload }) => {
            state.list = payload;
            state.isLoaded = true;
        },
        setSelectedProfession: (state, { payload }) => {
            state.selected = payload;
        },
        updateProfessionList: (state, { payload }) => {
            state.list = state.list.map((item) =>
                item.id === payload.id ? payload : item
            );
        },
        removeProfessionFromList: (state, { payload }) => {
            state.list = state.list.filter((item) => item.id !== payload);
        },
        clearSelectedProfession: (state) => {
            state.selected = {};
        },
        addProfessionToList: (state, { payload }) => {
            state.list = [...state.list, payload];
        },
    },
});

export const {
    setProfessions,
    setSelectedProfession,
    updateProfessionList,
    removeProfessionFromList,
    clearSelectedProfession,
    addProfessionToList,
} = professionSlice.actions;

export default professionSlice.reducer;
